/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import PartnerLogo from 'components/shared/logo/partner/partner';



/* ========== ~~~~~~~~~~ LOGO : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ settings, contentStatus, queueStatus, contentData }, { contentId }) => ({
    embedSettings: settings.embedSettings,
    currentContentStatus: !!contentId ? contentStatus[contentId] : null,
    currentContentSettings: !!contentId ? settings.contentSettings[contentId] : null,
    currentContentData: !!contentId ? contentData[contentId] : null,
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
    contentId,
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps
)(PartnerLogo);
